module.exports = __webpack_public_path__ + "fonts/payback_regular-webfont.c5f5abaa.woff";